import styled from 'styled-components';

const ContainerFullScreen = styled.div`
  top: 0;
  position: absolute;
  width: 100%;
  background-color: #fff;
  height: 100%;
  padding-top: 16px;
  margin-top: 0px;
  z-index: 11;

  div.buttonBack {
    margin-left: 16px;
    display: flex;
    justify-content: center;
  }
  @media (min-width: 640px) {
    position: relative;
    width: 100%;
    background-color: transparent;
    padding: 16px;
    z-index: 2;
    div.buttonBack {
      margin-left: 0px;
    }
  }
  @media (min-width: 992px) {
    padding-top: 88px;
    padding-left: 120px;
    z-index: 2;
  }
`;

const ContainerBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 24px 16px 24px;

  @media (min-width: 640px) {
    width: 744px;
    margin-bottom: 16px;
    padding: 0;
  }

  @media (min-width: 768px) {
    width: 696px;
    margin-bottom: 16px;
    padding: 0;
  }

  @media (min-width: 1280px) {
    width: 744px;
    margin-bottom: 16px;
    padding: 0;
  }
`;

const ContainerFake = styled.div`
  @media (max-width: 640px) {
    background: #ffffff;
    height: 1000px;
  }
`;

const EventDetailContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  div.eventDetailContainer {
    background-color: #fff;
    border-radius: 8px;
    padding: 0 16px 24px 16px;
    width: 100%;
    margin-bottom: 32px;
  }

  div.eventDetailButtom {
    background: initial;
    width: 100%;
  }

  div.tags {
    display: flex;
    gap: 8px;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }

  div.fields {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 6px;
    gap: 8px;
    display: flex;
    color: #161d1f;
    font-weight: 400;
  }

  @media (max-width: 639px) {
    div.eventDetailButtom {
      padding: 16px 0 24px 0;
    }
  }

  @media (min-width: 640px) {
    div.eventDetailContainer {
      padding: 24px;
    }
    div.eventDetailButtom {
      padding: 16px 0 24px 0;
    }
  }

  @media (min-width: 768px) {
    div.eventDetailContainer {
      width: 696px;
    }
    div.eventDetailButtom {
      width: 696px;
    }
  }

  @media (min-width: 1280px) {
    div.eventDetailContainer {
      width: 744px;
    }
    div.eventDetailButtom {
      width: 744px;
    }
  }
`;

const Title = styled.div`
  color: #161d1f;
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 16px;
`;

const Type = styled.div`
  color: #161d1f;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 2px;
`;

export {
  ContainerFake,
  ContainerFullScreen,
  EventDetailContainer,
  ContainerBottom,
  Title,
  Type
};
